import React from 'react'
import './footer.css'
import Fooder from '../../Images/Larger devices/image 12.png'
import SocialT from '../../Images/Larger devices/twitter.png'
import SocialF from '../../Images/Larger devices/facebook.png'
import SocialI from '../../Images/Larger devices/instagram.png'

function Footer() {
  return (
    <div className='mov'>
      <div className="row">
        <div className='col-sm-12 col-md-12 col-lg-4 stop'>
            <img src={Fooder} alt='' />
        </div>
        <div className='col-sm-12 col-md-12 col-lg-4 flip'>
            <img className='los' src={SocialT} alt='' /> <img className='cos' src={SocialF} alt='' /> <img className='dic' src={SocialI} alt='' />
        </div>
        <div className='col-sm-12 col-md-12 col-lg-4 star'>
            <p className='teg'>Copywright 2020 Bella Onojie.com</p>
        </div>
        </div>
    </div>
  )
}

export default Footer
